import { makeStyles } from '@mui/styles'

export const useStyles = makeStyles((theme) => ({//Estílos solamente del componente "LoginComponent"
  camara: {
    position: "relative",
    zIndex: 2,
    display: 'flex',
    alignContent: 'center',
    alignItems: 'center',
    justifyContent: 'center',
  },
  camaraMovil: {
    position: "relative",
    zIndex: 2,
    marginTop: '20%',
    ['@media only screen and (max-width: 812px)']: {
      marginTop: '13%',
      display: 'flex',
      alignContent: 'center',
      alignItems: 'center',
      justifyContent: 'center',
      top: '-17px',
    },
  },
  bocina: {
    position: "absolute",
    zIndex: 5,
  },
  bocinaMovil: {
    position: "absolute",
    marginTop: "50%",
    zIndex: 5,
  },
  formContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    margin: theme.spacing(1),
    width: '50% !important',
    ['@media only screen and (max-width: 812px)']: {
      width: '100% !important',
    },
  },
  title: {
    fontWeight: 600,
    width: '100%',
    paddingLeft: theme.spacing(1),
  },
  titlePrincipal: {
    fontWeight: 600,
    width: '100%',
    paddingLeft: theme.spacing(1),
    // fontSize: 24,
  },
  subTitle: {
    width: '100%',
    paddingLeft: theme.spacing(1),
    // fontSize: 19,
    marginBottom: '8% !important'
  },
  margin: {
    margin: theme.spacing(1),
  },
  acceptBtn: {
    display: 'flex',
    width: '100% !important',
    justifyContent: 'center',
    // marginTop: theme.spacing(4),
    fontWeight: 'bold',
  },
  cancelBtn: {
    display: 'flex',
    width: '100% !important',
    justifyContent: 'center',
    margin: theme.spacing(1),
    // marginTop: theme.spacing(1),
    fontWeight: 'bold',
  },
  topImage: {
    padding: theme.spacing(1),
  },
  captionRegister: {
    width: '100% !important',
  },
  wc100: {
    width: '100% !important',
    paddingTop: '4px !important',
    paddingLeft: '12px !important',
    paddingRight: '12px !important',
    paddingBottom: '4px !important',
  },
  pc12: {
    padding: '12px !important',
  },
  colContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  imageContent: {
    marginBottom: '8% !important',
    height: '80% !important',
    ['@media only screen and (max-width: 812px)']: {
      height: '75% !important',
      marginBottom: '8% !important',
    },
  },
  imageIcon: {
    marginTop: '3% !important',
    width: '50%',
    ['@media only screen and (max-width: 812px)']: {
      marginTop: '10% !important',
      width: '40%',
    },
  },
  containerImage: {
    display: 'grid !important',
    gridTemplateColumns: '100%',
    // height: '50vh !important',
    marginTop: 5,
    marginBottom: 5,
    // backgroundColor: theme.palette.background.paper,
    overflowY: 'none',
    ['@media only screen and (max-width: 812px)']: {
      gridTemplateColumns: '100%',
      height: '55vh !important',
    },
    // marginBottom: '5% !important'
  },

  centerContentInfoMessage: { //Help
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    width: '100%',
    height: '85vh',
    position: 'relative',
    alignItems: 'center',
    ['@media only screen and (max-width: 812px)']: {
      width: '100%',
      height: '88vh',
    }
  },

  imgHelp: { //Help
    height: '30vh',
    width: '50% important',
    ['@media only screen and (max-width: 812px)']: {
      width: '50% important',
      height: '25vh',
    }
  },

  textContent: {
    fontWeight: 'bold !important',
    width: '100%',
    ['@media only screen and (max-width: 812px)']: {
      width: '90%',
    }
  },

  imageEmogi: {
    display: 'block',
    marginTop: 0,
    marginLeft: 7,
    // height: 50
    width: '7%',
    ['@media only screen and (max-width: 812px)']: {
      width: '5%'
    }
  },

  imagenFondo: {
    height: '75vh',
    ['@media only screen and (max-width: 812px)']: {
      height: '85vh'
    }
  },
  mascara: {
    position: "absolute",
    zIndex: 3,
    height: '77vh',
  },
  imagen: {
    width: "100%",
    // height: "78vh",
  },
  videoClass: {
    width: '100% !important',
    height: '78vh !important',
    ['@media only screen and (max-width: 812px)']: {
      height: '100vh'
    }
  },
  btnCapturar: {
    position: "absolute",
    zIndex: 5,
    background: '#F5F5F5',
    borderRadius: ' 50% 50%',
    ['@media only screen and (max-width: 812px)']: {
      bottom: '5vh',
    }
  },
  continueBtn: {
    alignSelf: 'center',
    margin: '5px !impotant',
  },
  btnCapturarRecapturar: {
    // position: "absolute",
    zIndex: 5,
    width: '100%',
    textAlign: 'center',
    // textAling:'center',
    // background: '#F5F5F5',
    // borderRadius: ' 50% 50%'
  },
  mascaraMovil: {
    position: "absolute",
    zIndex: 3,
    height: '85vh',
    width: "100%",
    top: '10vh',
  },
  imagenMovil: {
    height: "100%",
    width: "100%",
  },
  centerContentDialog: { //Help
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    height: '79vh',
    position: 'relative',
    ['@media only screen and (max-width: 812px)']: {
      height: '75vh',
    }
  },
  imgHelp1: { //Help
    height: '30vh',
    ['@media only screen and (max-width: 812px)']: {
      height: '28vh',
    }
  },
  instructiontoPopUp: { //Help
    marginLeft: theme.spacing(1),
    ['@media only screen and (max-width: 812px)']: {
      marginLeft: theme.spacing(0)
    }
  },
  centerButtons: { //Help
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    position: 'relative',
  },
  cargarDocsBtn: {
    width: '100%',
    alignSelf: 'center !important',
    marginBottom: '3px'
  },

  swiper: {
    "& .swiper-pagination-container .swiper-pagination-dot__default": {
      backgroundColor: `#C9D3DC !important`,
      "&.active": {
        backgroundColor: `${theme.palette.primary.light} !important`,
        width: '37px',
        height: '9px',
        borderRadius: '20px',
        // backgroundColor: `${theme.palette.primary.main} !important`,
      }
    },
  },

  helpImage: {
    width: '50% !importnt',
    ['@media only screen and (max-width: 812px)']: {
      width: '40% !importnt',
    }
  },
  imgSelfieClass: {
    marginTop: '48px !importnt',
    ['@media only screen and (max-width: 812px)']: {
      marginTop: '48px !importnt',
    }
  }
}))
